<div *ngIf="type === ''" class="swiper-container h-full" [swiper]="swiperAutoplayConfig" (indexChange)="eventDispatcher($event)">
	<div class="swiper-wrapper">
		<div *ngFor="let product of products" class="swiper-slide w-full cursor-pointer h-full flex sm:w-auto" [ngClass]="type === '' ? '' : ''">
			<div (click)="redirect(product)" class="relative flex-1">
				<img class="w-full h-full object-contain object-center" [src]="product.variants[0].images.length > 0 ? product.variants[0].images[0].url : default_image" alt="{{ product.name }}" />

				<!-- <div class="absolute top-0 left-0 ml-2 mt-4" *ngIf="logoProduct[product.product] != undefined">
                    <img [src]="logoProduct[product.product]" alt="Logo" class="w-24 h-auto"/>
                </div> -->
				<div *ngIf="product.promoActive" class="transform rotate-90 absolute top-7 right-2 w-22 h-8/9">
					<span class="bg-principal font-bold flex justify-center items-center text-white text-sm w-full h-full uppercase">{{ promotionInfo.name }}</span>
				</div>
			</div>

			<!-- <p (click)="redirect(product)" routerLink="/{{this.id_store_current}}/product/{{product.slugName}}" class="text-center mt-2 font-normal leading-6"> {{product.variants[0].name}} </p>

            <div class="text-center mt-2">
                <p class="font-poppins font-normal text-info leading-6">{{product.variants[0].price === 0 ? '' : product.variants[0].price | currencyPersonalized}}</p>
                <div class="text-center mt-2 mb-2 place-items-center"></div>
                <a (click)="redirect(product)" routerLink="/{{this.id_store_current}}/product/{{product.slugName}}" class="border border-principal text-info font-normal text-sm tracking-wide bg-principal hover:bg-secundario hover:border-secundario focus:bg-secundario focus:border-secundario text-center place-items-center py-2 px-5 w-45">
                    {{'buttons.verMas' | translate}}
                </a>
            </div> -->
		</div>
	</div>
</div>
<div *ngIf="type === ''" class="absolute left-8 md:left-0 bottom-1/2 transform -translate-y-full mb-8 md:mb-0 md:translate-y-0 md:bottom-8 z-20 md:w-1/2">
	<div class="max-w-sm m-auto">
		<div class="flex gap-3" *ngIf="activeHeroInStock()">
			<button
				type="button"
				(click)="redirect(products[indexProdActiveN])"
				class="my-2 bg-principal text-white text-sm px-6 py-2 transform hover:scale-125 hover:z-10 transition-transform ease-in-out duration-500 whitespace-nowrap"
			>
				Add to Cart
			</button>
			<!-- <button type="button" class="my-2 bg-principal-claro text-principal text-sm px-6 py-2 transform hover:scale-125 hover:z-10 transition-transform ease-in-out duration-500 whitespace-nowrap ">
                Buy Now
            </button> -->
			<button
				(click)="buyNow = true; addItemTocart(products[indexProdActiveN])"
				class="my-2 bg-principal-claro text-white text-sm px-6 py-2 transform hover:scale-125 hover:z-10 transition-transform ease-in-out duration-500 whitespace-nowrap"
			>
				<p class="">{{ 'buttons.comprarAhora' | translate }}</p>
			</button>
		</div>
		<div *ngIf="!activeHeroInStock() && products[indexProdActiveN]" class="my-2 flex flex-row items-center justify-center gap-2 bg-principal-claro text-white text-sm px-4 py-2 border-2 border-principal whitespace-nowrap">
			<span>{{ outOfStockCopyKey | translate }}</span>
			<span class="material-icons-outlined text-lg">shopping_bag</span>
		</div>
		<div class="swiper-pagination swiper-paginationBest p-2"></div>
		<!-- <div class="swiper-button-next"></div>
		<div class="swiper-button-prev"></div> -->
	</div>
</div>

<!-- <div *ngIf="type === ''" class="absolute left-0 bottom-0 z-20 w-1/2 text-center">
    <button type="button" (click)="redirect(product)" class="my-2 bg-principal text-center px-3 font-semibold text-lg text-white hover:bg-principal-hover focus:bg-principal-hover focus:outline-none rounded-full whitespace-nowrap w-full">
            {{'buttons.verMas' | translate}}
    </button>
    <div class="swiper-pagination justify-center"></div>
    <div class="swiper-button-next"></div>
    <div class="swiper-button-prev"></div>
</div> -->

<!-- Si es new arrivals -->
<div *ngIf="type === 'newArrivals'" class="grid grid-cols-2 md:grid-cols-3 max-w-screen-xl gap-10 lg:gap-20 mx-auto">
	<div
		*ngFor="let product of products"
		class="bg-transparent swiper-slide w-full h-auto flex flex-col group border-b border-transparent hover:border-principal-hover transition-all duration-1000 sm:w-auto pb-2"
	>
		<div class="relative bg-white bg-cover p-0" style="background-image: url('/assets/images/modal-number-bg.png');">
			<button *ngIf="false" class="z-30 ml-4 h-10 w-10 absolute top-2 right-2 z-20 group items-center focus:outline-none inline-flex" type="button" (click)="addOrRemoveFavorite(product)">
				<span
					class="group-hover:bg-principal group-focus:bg-principal group-hover:text-white group-focus:text-white focus:outline-none icon-favoritos text-xl text-principal bg-white rounded-full p-2 transition-all duration-1000"
					*ngIf="getIsInFav(product) == false"
				></span>
				<span class="icon-favoritos-completo text-xl text-principal bg-white rounded-full p-2" *ngIf="getIsInFav(product)"></span>
			</button>
			<div (click)="redirect(product)" class="relative flex-1 cursor-pointer w-full overflow-hidden" style="aspect-ratio: 1/1.1">
				<img
					[src]="product.variants[0].images.length > 0 ? product.variants[0].images[1].url : default_image"
					alt="{{ product.name }}"
					class="absolute w-full h-full top-0 left-0 object-cover z-10 group-hover:opacity-0 opacity-100 transition-opacity ease-in-out duration-1000"
				/>
				<img
					[src]="product.variants[0].images.length > 0 ? product.variants[0].images[0].url : default_image"
					alt="{{ product.name }}"
					class="absolute w-full h-full top-0 left-0 z-20 object-cover opacity-0 group-hover:opacity-100 transition-opacity ease-in-out duration-1000"
				/>
			</div>
			<!-- <div class="absolute top-0 left-0 ml-2 mt-4" *ngIf="logoProduct[product.product] != undefined">
                    <img [src]="logoProduct[product.product]" alt="Logo" class="w-24 h-auto"/>
                </div> -->
		</div>
		<div class="text-left px-0 pb-1 lg:pb-3 flex-2 flex flex-col items-start justify-start md:gap-y-2 lg:gap-y-6">
			<h2 (click)="redirect(product)" class="cursor-pointer pt-2 font-semibold text-sm lg:text-base leading-5">{{ product.variants[0].name }}</h2>
			<div class="force-truncate text-gris-medio leading-4 truncate w-full h-4 text-sm overflow-hidden" [innerHTML]="processHTML(product.variants[0].subtitle)"></div>
			<ng-container *ngIf="tagsList.length > 0">
				<p class="leading-4 text-xs text-principal py-2">
					<span *ngFor="let tag of tagsList; let i = index">{{ tag }} <span *ngIf="i < tagsList.length - 1"> / </span></span>
				</p>
			</ng-container>
			<!-- <div class="text-center mt-2 mb-2 place-items-center"></div> -->
		</div>
		<!-- <div class="w-full flex flex-row text-center mt-2 mb-2 place-items-center">
                <p class="font-poppins font-normal text-info leading-6">{{product.variants[0].price === 0 ? '' : product.variants[0].price | currencyPersonalized}}</p>
                
                <a
                class="mt-1 inline-block text-center place-items-center px-3 text-sm focus:underline hover:underline focus:outline-none"
                (click)="redirect(product)"
                routerLink="/{{ this.id_store_current }}/product/{{ product.slugName }}"
                >
                {{ 'buttons.verMas' | translate }}
            </a>
            </div> -->
		<div class="flex flex-col lg:flex-row w-full h-full justify-center md:justify-start lg:justify-end px-4 md:px-0 items-center md:gap-y-2 lg:gap-y-0 md:mt-2 lg:mt-0">
			<p class="md:w-full lg:w-2/4 text-base lg:text-lg font-bold leading-6 md:text-center lg:text-left">{{ product.variants[0].price === 0 ? '' : (product.variants[0].price | currencyPersonalized) }}</p>
			<ng-container *ngIf="productListingInStock(product)">
				<button
					class="w-full md:w-full lg:w-2/3 py-2 lg:mr-2 my-1  text-center text-gris-medio bg-gris-claro rounded-full hover:bg-gris-medio hover:text-gris-claro transition-all duration-300 text-sm"
					(click)="addItemTocart(product)"
				>
					Add to Cart
				</button>
				<button
					class="w-full md:w-full lg:w-2/3 py-2 mb-1 lg:mb-0 sm:mb-0 text-center text-white bg-principal rounded-full hover:bg-principal-hover transition-all duration-300 text-base"
					(click)="redirect(product)"
				>
					Buy Now
				</button>
			</ng-container>
			<div
				*ngIf="!productListingInStock(product)"
				class="w-full md:w-full lg:w-2/3 flex flex-row items-center justify-center gap-2 py-2 my-1 text-center bg-principal-claro text-white border-2 border-principal rounded-full text-sm lg:text-base"
			>
				<span>{{ outOfStockCopyKey | translate }}</span>
				<span class="material-icons-outlined text-lg">shopping_bag</span>
			</div>
		</div>
	</div>
	<!-- <div class="swiper-pagination swiper2"></div>
    <div class="swiper-button-next swiper2"></div>
    <div class="swiper-button-prev swiper2"></div> -->
</div>

<!-- Si es recommended -->
<div *ngIf="type === 'recommended'" class="swiper-container" [swiper]="swiperAutoplayConfig3">
	<div class="swiper-wrapper pb-4">
		<div *ngFor="let product of products" class="bg-principal-claro swiper-slide rounded-lg w-full h-auto flex flex-col sm:hover:box-shadow sm:hover:shadow-md sm:w-auto">
			<div (click)="redirect(product)" class="relative flex-1 cursor-pointer">
				<div class="absolute top-2 right-4 flex items-center" *ngIf="tag != null">
					<span class="bg-secundario text-white text-4xl flex items-center justify-center -mr-2 w-9 h-9 z-20 rounded-full border-2 border-white">
						<i class="icon-mas text-md"></i>
					</span>
					<span class="bg-secundario text-md text-white px-4 py-1 z-10" style="border-radius: 0 10px 10px 0">{{ tag.tag.name }}</span>
				</div>

				<img class="rounded-t-lg w-full h-52 object-cover object-center" [src]="product.variants[0].images.length > 0 ? product.variants[0].images[0].url : default_image" alt="{{ product.name }}" />
				<div *ngIf="product.promoActive" class="transform rotate-90 absolute top-7 right-2 w-22 h-8/9">
					<span class="bg-principal font-bold flex justify-center items-center text-white text-sm font-poppins w-full h-full uppercase">{{ promotionInfo.name }}</span>
				</div>
				<!-- <div class="absolute top-0 left-0 ml-2 mt-4" *ngIf="logoProduct[product.product] != undefined">
                    <img [src]="logoProduct[product.product]" alt="Logo" class="w-24 h-auto"/>
                </div> -->
			</div>
			<div class="mt-2 px-4 pb-6 flex-1 flex flex-col gap-2">
				<h2 (click)="redirect(product)" routerLink="/{{ this.id_store_current }}/product/{{ product.slugName }}" class="cursor-pointer pt-2 text-2xl font-bold leading-6">
					{{ product.variants[0].name }}
				</h2>
				<p class="flex-1 text-sm font-normal text-white leading-4">{{ product.description }}</p>
				<p class="text-center text-xl font-bold leading-6">{{ product.variants[0].price | currencyPersonalized }}</p>
				<a
					class="w-full block text-center px-3 font-semibold text-lg bg-principal text-white hover:bg-principal-hover focus:bg-principal-hover focus:outline-none rounded-full whitespace-nowrap"
					(click)="redirect(product)"
					routerLink="/{{ this.id_store_current }}/product/{{ product.slugName }}"
				>
					{{ 'buttons.verMas' | translate }}
				</a>
			</div>
		</div>
	</div>
	<!-- <div class="swiper-pagination">pag</div>
    <div class="swiper-button-next">next</div>
    <div class="swiper-button-prev">prev</div> -->
</div>
